import React from "react"
import BillingRoute from "./billing"
import CashSalesRoute from "./cash-sales"
import CustomerTempRoute from "./customer-temp"
import DeliveryOrderRoute from "./delivery-order"
import ListScheduleRoute from "./list-schedule"
import PaymentInvoiceRoute from "./payment-invoice"
import ReturnPriceRoute from "./return-price"
import ReturnSellingRoute from "./return-selling"
import SalesInvoiceRoute from "./sales-invoice"
import SalesOrderRoute from "./sales-order"
import SalesTargetRoute from "./sales-target"
import SellingPriceRoute from "./selling-price"
import TaskRoute from "./task"
import VisitScheduleRoute from "./visit-schedule"
import { Route } from "react-router-dom"
export default function SalesRoutes( props ) {
    return (
    <Route path="/sales">
       {BillingRoute(props)}
       {CashSalesRoute(props)}
       {CustomerTempRoute(props)}
       {DeliveryOrderRoute(props)}
       {ListScheduleRoute(props)}
       {PaymentInvoiceRoute(props)}
       {ReturnPriceRoute(props)}
       {ReturnSellingRoute(props)}
       {SalesInvoiceRoute(props)}
       {SalesOrderRoute(props)}
       {SalesTargetRoute(props)}
       {SellingPriceRoute(props)}
       {TaskRoute(props)}
       {VisitScheduleRoute(props)}
    </Route>
    )
}